import Mock from 'mockjs'

const List = []
const ListCh = []
const count = 100

const baseContent = '<p>I am testing data, I am testing data.</p><p><img src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>'
const image_uri = 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3'

for (let i = 0; i < count; i++) {
  List.push(Mock.mock({
    id: '@increment(1)', // id
    lasttm: +Mock.Random.date('T'), // 上传时间
    savetm: +Mock.Random.date('T'), // 入库时间
    lastuser: '@first', // 上传人
    reviewer: '@first',
    // locality: '@integer(2000, 2020)年',//管理单位
    username: '@first', // 用户姓名
    pwd: '123456',
    gropname: '@first', // 分组名
    'locality|1': ['水利部', '长江委水位'], // 管理单位
    'instcd|1': ['0', '1'], // /管理单位
    memo: '@integer(2000, 2020)年', // 备注
    content_short: 'mock data',
    content: baseContent,
    forecast: '@float(0, 100, 2, 2)',
    importance: '@integer(1, 3)',
    'type|1': ['CN', 'US', 'JP', 'EU'],
    'usertype|1': ['0', '1'], // 文件状态
    display_time: '@datetime',
    comment_disabled: true,
    pageviews: '@integer(300, 5000)',
    image_uri,
    platforms: ['a-platform']
  }))
}
for (let i = 0; i < count; i++) {
  ListCh.push(Mock.mock({
    id: '@increment(1)', // id
    lasttm: +Mock.Random.date('T'), // 上传时间
    savetm: +Mock.Random.date('T'), // 入库时间
    STCD: '@integer(10000000, 99999999)',
    STNM: '测站@integer(1, 100)',
    SLTM: +Mock.Random.date('T'), //
    CHANNEL: '短信', //
    'WARNING|1': ['超警戒', '正常'], //
    SLCON: '@first', //
    DYP: '@integer(1, 10)', //
    SZ: '@integer(1, 10)', //
    'WTH|1': ['雨', '雨夹雪'], //
    SQ: '@integer(1, 10)', //
    'WPTN|1': ['涨', '落', '平'], //
    DAQ: '@integer(1, 10)', //
    'QM|1': ['水位流量关系曲线'], //
    MXQ: '@integer(1, 10)', //
    MXQTM: +Mock.Random.date('T'), //
    MNQ: '@integer(1, 10)', //
    MNQTM: +Mock.Random.date('T'), //

    lastuser: '@first', // 上传人
    reviewer: '@first',
    // locality: '@integer(2000, 2020)年',//管理单位
    username: '@first', // 用户姓名
    pwd: '123456',
    gropname: '@first', // 分组名
    'locality|1': ['水利部', '长江委水位'], // 管理单位
    'instcd|1': ['0', '1'], // /管理单位
    memo: '@integer(2000, 2020)年', // 备注
    content_short: 'mock data',
    content: baseContent,
    forecast: '@float(0, 100, 2, 2)',
    importance: '@integer(1, 3)',
    'type|1': ['CN', 'US', 'JP', 'EU'],
    'usertype|1': ['0', '1'], // 文件状态
    display_time: '@datetime',
    comment_disabled: true,
    pageviews: '@integer(300, 5000)',
    image_uri,
    platforms: ['a-platform']
  }))
}

export default [
  {
    url: '/vue-element-admin/Auditing/GetUserList',
    type: 'get',
    response: config => {
      const { instcd, usertype, username, page = 1, limit = 20, sort } = config.query

      const mockList = List.filter(item => {
        if (instcd && item.instcd !== instcd) return false
        if (usertype && item.usertype !== usertype) return false
        if (username && item.username.indexOf(username) < 0) return false
        return true
      })

      // if (sort === '-id') {
      //   mockList = mockList.reverse()
      // }

      const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

      return {
        code: 20000,
        // data: {
        //   total: mockList.length,
        //   items: pageList
        // }
        data: pageList,
        total: mockList.length
      }
    }
  },
  {
    url: '/vue-element-admin/Auditing/getCheckList',
    type: 'get',
    response: config => {
      const { instcd, usertype, username, page = 1, limit = 20, sort } = config.query

      const mockList = ListCh.filter(item => {
        if (instcd && item.instcd !== instcd) return false
        if (usertype && item.usertype !== usertype) return false
        if (username && item.username.indexOf(username) < 0) return false
        return true
      })

      // if (sort === '-id') {
      //   mockList = mockList.reverse()
      // }

      const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

      return {
        code: 20000,
        // data: {
        //   total: mockList.length,
        //   items: pageList
        // }
        data: pageList,
        total: mockList.length
      }
    }
  },
  {
    url: '/vue-element-admin/Auditing/AddUser',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },

  {
    url: '/vue-element-admin/Auditing/UpdateUser',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },
  {
    url: '/vue-element-admin/Auditing/getMarkDataList',
    type: 'get',
    response: _ => {
      return {
        code: 20000,
        data: [{
          id: 1,
          label: '报文模板',
          children: [{
            id: 11,
            label: '河道日报(3)'
          },
          {
            id: 12,
            label: '河道日旬报(3)'
          }, {
            id: 13,
            label: '河道日旬月报(3)'
          },
          {
            id: 14,
            label: '河道加报(3)'
          },
          {
            id: 15,
            label: '水情旬报(3)'
          },
          {
            id: 16,
            label: '水情旬月报(3)'
          },
          {
            id: 17,
            label: '雨量加报(3)'
          },
          {
            id: 18,
            label: '水文日报(3)'
          },
          {
            id: 19,
            label: '水文旬报(3)'
          },
          {
            id: 20,
            label: '水文月报(3)'
          },
          {
            id: 21,
            label: '水库日报(3)'
          },
          {
            id: 22,
            label: '水库旬报(3)'
          },
          {
            id: 23,
            label: '水库月报(3)'
          },
          {
            id: 24,
            label: '水库简报旬报(3)'
          },
          {
            id: 25,
            label: '水库简报月报(3)'
          }
          ]
        }]
      }
    }
  },
  {
    url: '/vue-element-admin/Auditing/DeleteUserList',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  }
]

